import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { SecondaryButton, TransparentBgButton } from 'components/Shared/Button'

// Shared confirmation prompt for step 1's platform and Campaign Type
// switches — both can affect already-configured content (targeting,
// media), so title/body are passed in per case rather than hardcoded here.
export default function ConfirmSetupChangeModal({ title, body, onCancel, onConfirm }) {
  const { t } = useTranslation()

  return (
    <div className="yes-no-prompt">
      <div className="yes-no-prompt_content">
        <h1>{title}</h1>
        <p>{body}</p>
      </div>

      <div className="yes-no-prompt_footer">
        <TransparentBgButton
          text={t('Recommendations.confirmSetupChange.btnCancel')}
          onClick={onCancel}
          color="navy"
        />

        <SecondaryButton
          className="bt"
          text={t('Recommendations.confirmSetupChange.btnConfirm')}
          fullWidth={false}
          onClick={onConfirm}
        />
      </div>
    </div>
  )
}

ConfirmSetupChangeModal.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}
